import Wizard from './Wizard';
export { Wizard as default };
